import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const TransitionPageWrapper = () => {
  const location = useLocation();

  const isDetailPage = /^\/articles\/\d+/.test(location.pathname);

  const variants = {
    list: {
      initial: { opacity: 0, x: 100 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: -100 },
    },
    detail: {
      initial: { opacity: 0, x: -100 },
      animate: { opacity: 1, x: 0 },
      exit: { opacity: 0, x: 100 },
    },
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={isDetailPage ? variants.detail.initial : variants.list.initial}
        animate={isDetailPage ? variants.detail.animate : variants.list.animate}
        exit={isDetailPage ? variants.detail.exit : variants.list.exit}
        transition={{ duration: 1.5, ease: "easeInOut" }}
        className="w-full"
      >
        <Outlet />
      </motion.div>
    </AnimatePresence>
  );
};

export default TransitionPageWrapper;
